import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `vite`,

  name: {
    [LOCALES.EN_US]: `Vite`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.tool, TYPES.framework],

  tags: [],
} as const satisfies TTerm
